import { faTable } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { TableRow as ngtTableRow } from "../../../api/dtos/dtos";
import NGTTable from "./NGTTable";

interface ITablesCardProps {
    sightingTableData: ngtTableRow[] | undefined,
    damageTableData: ngtTableRow[] | undefined,
    controlTableData: ngtTableRow[] | undefined
}

const TablesCard: FC<ITablesCardProps> = ({
    sightingTableData,
    damageTableData,
    controlTableData
}) => {

    return (
        <Card 
            variant='outlined'
            sx={{
                marginY: '15px'
            }}
        >
            <CardContent>
                <Grid container spacing={1} alignItems={"center"}>
                    <Grid item xs={12}>
                        <Box display="flex" alignItems={"center"}>
                            <FontAwesomeIcon icon={faTable} style={{ fontSize: '1.2rem', paddingRight: "5px" }} />
                            <Typography paddingLeft={"5px"} fontSize={24}>
                                Tables
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
                
                {sightingTableData && (
                    <>
                        <Box sx={{padding: "10px"}} />
                        <Box
                            sx={{ 
                                border: '2px solid #4cc61b',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <NGTTable
                                tableId={"sighting-table"}
                                tableTitle={"Sighting Type"}
                                tableRows={sightingTableData}
                            />
                        </Box>
                    </>
                )}

                {damageTableData && (
                    <>
                        <Box sx={{padding: "10px"}} />
                        <Box
                            sx={{ 
                                border: '2px solid #f23e3e',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <NGTTable
                                tableId={"damage-table"}
                                tableTitle={"Damage Type"}
                                tableRows={damageTableData}
                            />
                        </Box>
                    </>
                )}

                {controlTableData && (
                    <>
                        <Box sx={{padding: "10px"}} />
                        <Box
                            sx={{ 
                                border: '2px solid #0300e0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <NGTTable
                                tableId={"control-table"}
                                tableTitle={"Control Type"}
                                tableRows={controlTableData}
                            />
                        </Box>
                    </>
                )}

            </CardContent>
        </Card>
    );
}

export default TablesCard;